import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { getSEPTemplates } from "services/sepTemplates";
import { getTemplates } from 'services/templates';
import { Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export function SEPTemplateSelect({
  onChange = (sepTemplate) => { },
  filters = {},
}) {
  const [sepTemplates, setSEPTemplates] = React.useState([]);

  const handleChange = (e, newValue) => onChange(newValue);

  React.useEffect(() => {
    (async () => {
      const { sepTemplates } = await getSEPTemplates(filters);
      setSEPTemplates(sepTemplates);
    })();
  }, [filters]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={sepTemplates}
      renderInput={(params) => (
        <TextField {...params} label="Choose a SEP Template" />
      )}
      isOptionEqualToValue={(option, value) => option?._id === value?._id}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Typography
          {...props}
          component="li"
          sx={{ fontSize: 14, fontWeight: "normal" }}
        >
          {option.name}
        </Typography>
      )}
      onChange={handleChange}
    />
  );
}

export function SEPTemplateMultiSelect({
  onChange = (sepTemplates) => { },
  filters = {},
  setAllTemplateList = (list) => {},
}) {
  const [sepTemplates, setSEPTemplates] = React.useState([]);

  const handleChange = (e, newValue) => {
    onChange(newValue); 
  };

  React.useEffect(() => {
    (async () => {
      const { sepTemplates } = await getSEPTemplates(filters);
      const initialTemplates = sepTemplates.map((el) => el._id); 
      setAllTemplateList(initialTemplates);
      setSEPTemplates(sepTemplates); 
    })();
  }, [filters]);

  return (
    <Autocomplete
      fullWidth
      multiple
      id="sep-templates"
      size="small"
      options={sepTemplates}
      disableCloseOnSelect
      onChange={handleChange} 
      isOptionEqualToValue={(option, value) => option?._id === value?._id} 
      getOptionLabel={(option) => option.name}
      renderOption={(props, option, { selected }) => (
        <Typography
          {...props}
          component="li"
          sx={{ fontSize: 14, fontWeight: "normal", color: "inherit" }}
        >
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon} 
            checked={selected}
          />
          {option.name} 
        </Typography>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choose Templates"
        />
      )}
    />
  );
}

export function InterviewTemplateSelect({
  filters,
  onChange = (interviewTemplate) => { },
  setAllTemplateList = (list) => { }
}) {
  const [interviewTemplates, setInterviewTemplates] = React.useState([]);

  const handleChange = (e, newValue) => onChange(newValue);

  React.useEffect(() => {
    (async () => {
      const { interviewTemplates } = await getTemplates(filters);
      const initialTemplates = interviewTemplates.map((el) => (el._id));
      setAllTemplateList(initialTemplates);
      setInterviewTemplates(interviewTemplates);
    })();
  }, [filters, setAllTemplateList]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={interviewTemplates}
      renderInput={(params) => (
        <TextField {...params} label="Choose Interview Template" />
      )}
      isOptionEqualToValue={(option, value) => option._id.toString() === value._id.toString()}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Typography
          {...props}
          component="li"
          sx={{ fontSize: 14, fontWeight: "normal" }}
        >
          {option.name}
        </Typography>
      )}
      onChange={handleChange}
    />
  );
}
